<template>
    <div>
        <div v-if="chartData && chartData.data" class="reports-charts mx-4 my-4">
            <div class="reports-charts-wrap m-0 row">
                <v-col cols="12" sm="12" md="12" xl="6" class="reports-charts-col">
                    <div class="reports-charts-card extend">
                        <div class="reports-charts-card-title" @click="$emit('setDataTable', 'all-patients')">
                            <div class="title">
                                <h4 class="link">{{ t('reports::title.adverse_events') }}</h4>
                            </div>
                        </div>
                        <div class="reports-charts-card-chart">
                            <report-chart-component
                                ref="comboChartComponent"
                                :data="chartData.data"
                                :meta="chartData.meta.filters"
                                :height="chartsHeight.adverse_events"
                                show-grid
                                combo
                            ></report-chart-component>
                        </div>
                    </div>
                </v-col>
                <v-col
                    v-if="can('api.v1.reports.red-patients') && chartData.data.red_patients"
                    cols="12"
                    sm="12"
                    md="6"
                    xl="3"
                    class="reports-charts-col"
                >
                    <div class="reports-charts-card bg-red">
                        <div class="reports-charts-card-title">
                            <div class="title">
                                <h4>{{ t('reports::reports_types.red_patients') }}</h4>
                            </div>
                            <div class="stats">
                                <p>
                                    <span>{{ chartData.meta.reports.red_patients.blood_results_count }}</span>
                                    <span
                                        >&nbsp;({{ chartData.meta.reports.red_patients.patients_count }}
                                        {{ t('reports::label.patients') }})</span
                                    >
                                </p>
                            </div>
                        </div>
                        <div class="reports-charts-card-chart">
                            <report-chart-component
                                ref="comboChartComponent"
                                :data="chartData.data.red_patients"
                                :meta="chartData.meta.filters"
                                :height="chartsHeight.red_patients"
                                color="red"
                                show-grid
                            ></report-chart-component>
                        </div>
                        <div class="reports-charts-card-actions">
                            <v-btn
                                color="red"
                                rounded
                                small
                                outlined
                                block
                                @click="$emit('setDataTable', 'red-patients')"
                                >{{ t('reports::button.view_blood_results') }}
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-col>
                <v-col
                    v-if="can('api.v1.reports.amber-patients') && chartData.data.amber_patients"
                    cols="12"
                    sm="12"
                    md="6"
                    xl="3"
                    class="reports-charts-col"
                >
                    <div class="reports-charts-card bg-amber">
                        <div class="reports-charts-card-title">
                            <div class="title">
                                <h4>{{ t('reports::reports_types.amber_patients') }}</h4>
                            </div>
                            <div class="stats">
                                <p>
                                    <span>{{ chartData.meta.reports.amber_patients.blood_results_count }}</span>
                                    <span
                                        >&nbsp;({{ chartData.meta.reports.amber_patients.patients_count }}
                                        {{ t('reports::label.patients') }})</span
                                    >
                                </p>
                            </div>
                        </div>
                        <div class="reports-charts-card-chart">
                            <report-chart-component
                                ref="comboChartComponent"
                                :data="chartData.data.amber_patients"
                                :meta="chartData.meta.filters"
                                :height="chartsHeight.amber_patients"
                                color="amber"
                                show-grid
                            ></report-chart-component>
                        </div>
                        <div class="reports-charts-card-actions">
                            <v-btn
                                color="amber"
                                rounded
                                small
                                outlined
                                block
                                @click="$emit('setDataTable', 'amber-patients')"
                                >{{ t('reports::button.view_blood_results') }}
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-col>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ReportChartsComponent',
    props: {
        chartData: {
            type: Object,
            require: true,
            default: () => {},
        },
    },
    data() {
        return {
            chartsHeight: {
                adverse_events: 325,
                overdue_patients: 248,
                amber_patients: 248,
                red_patients: 248,
            },
        };
    },
    computed: {},
    watch: {},
    created() {},
    destroyed() {},
    mounted() {},
    methods: {
        goTo(type) {
            switch (type) {
                case 'due_for_the_week':
                    return this.$root.goTo(route('patients.index', { type: 'due_for_the_week' }));
                case 'newly_registered':
                    return this.$root.goTo(route('patients.index', { type: 'newly_registered' }));
                case 'newly_restarted':
                    return this.$root.goTo(route('patients.index', { type: 'newly_restarted' }));
                case 'newly_transferred':
                    return this.$root.goTo(route('patients.index', { type: 'newly_transferred' }));
                case 'newly_re_challenged':
                    return this.$root.goTo(route('patients.index', { type: 'newly_re_challenged' }));
                default:
                    return this.$root.goTo(route('patients.index'));
            }
        },
    },
};
</script>
